import { useState, useCallback } from "react";
import { ProductService } from "../../../services/ProductService.js";

const productService = new ProductService();

const useTiposProducto = (baseUrl, empresa, nombreEmpresa) => {
  const [tipoProductos, setTipoProductos] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTipoProductos = useCallback(async () => {
    if (!empresa) {
      console.error("No hay empresa seleccionada");
      alert("Seleccione una empresa");
      return;
    }

    if (!nombreEmpresa) {
      console.error("No se pudo obtener el nombre de la empresa");
      alert("Error al obtener el nombre de la empresa");
      return;
    }

    try {
      setLoading(true);
      const tipos = await productService.getTiposProductoByEmpresa(baseUrl, nombreEmpresa);

      if (!Array.isArray(tipos)) {
        console.error("Error: Formato de respuesta inválido");
        return;
      }

      setTipoProductos(tipos);
    } catch (error) {
      alert("Error al cargar los tipos de producto");
    } finally {
      setLoading(false);
    }
  }, [baseUrl, empresa, nombreEmpresa]);

  return { tipoProductos, setTipoProductos, loading, setLoading, fetchTipoProductos };
};

export default useTiposProducto;
